<template>
    <!-- 直播预告 - 未开启 - 预告 - 预约 未预约 未开启 -->
    <div
        :class="['liveCardWrap']"
        @click.stop.prevent="handleClickDetailPage"
    >
        <div class="liveCardMain">
            <div class="liveCardLeft">
                <div class="liveCardTitle">直播预告</div>
                <div class="liveCardContent">
                    <p v-html="strParseFace(info.content)"></p>
                </div>
                <div class="liveCardTime">{{userInfo.title}}·{{info.preview_live_time_show}}开播</div>
            </div>
            <div class="liveCardRight">
                <button
                    :class="[{
                        liveCardAppPoint: !ending && info.room_preview_state == '0', // 未预约
                        liveCardAppPointCk: !ending && info.room_preview_state == '1', // 已预约
                        liveCardLight: ending && info.room_state == '1', // 直播中
                    }]"
                    @click.stop.prevent="handleClick"
                >{{liveStr}}</button>
            </div>
        </div>
    </div>
</template>
<script>
import userHomeApi from "@/api/user_home/index.js";
import { Toast, Dialog } from 'vant';
import { u_id } from "@/utils/urlQuery";
import { isLoginInfo  } from "@/utils/index";
export default {
    name: "liveCard",
    props: {
        info: {
            type: Object
        },
        userInfo: {
            type: Object
        },
        pageName: {
            type: String,
            default: "teacher"
        },
    },
    data() {
        return {
            faceList: { "\u5fae\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_weixiao@3x.png", "\u9707\u60ca": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zhenjing@3x.png", "\u6487\u5634": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_piezui@3x.png", "\u8272": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_se@3x.png", "\u5927\u54ed": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_daku@3x.png", "\u9177": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ku@3x.png", "\u594b\u6597": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_fendou@3x.png", "\u7591\u95ee": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_yiwen@3x.png", "\u574f\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_huaixiao@3x.png", "\u9634\u9669": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_yinxian@3x.png", "\u4eb2\u4eb2": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_qinqin@3x.png", "\u53ef\u601c": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_kelian@3x.png", "OK": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_OK@3x.png", "\u98de\u543b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_feiwen@3x.png", "\u60b2\u4f24": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_beishang@3x.png", "\u6c57": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_han@3x.png", "\u6342\u8138": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_wulian@3x.png", "\u5927\u6012": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_danu@3x.png", "\u6012\u706b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_nuhuo@3x.png", "\u5455": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ou@3x.png", "dog": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_dog@3x.png", "\u94b1": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_qian@3x.png", "\u5410\u8840": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_tuxue@3x.png", "\u6342\u5634\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_wuzuixiao@3x.png", "\u61f5": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_meng@3x.png", "\u53cb\u5584": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_youshan@3x.png", "\u60e8": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_can@3x.png", "\u4e27": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_sang@3x.png", "\u6311\u7709": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_tiaomei@3x.png", "\u7b11\u54ed": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_xiaoku@3x.png", "\u7761\u89c9": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_shuijiao@3x.png", "\u53ef\u7231": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_keai@3x.png", "\u5657": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_pu@3x.png", "\u6c14\u6124": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_qifen@3x.png", "\u5927\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_daxiao@3x.png", "\u611f\u5192\u4e86": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_kouzhao@3x.png", "\u5201\u96be": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_diaonan@3x.png", "\u67e0\u6aac": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ningmeng@3x.png", "\u771f\u725b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zhenniu@3x.png", "\u65e9\u5b89": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zaoan@3x.png", "\u665a\u5b89": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_wanan@3x.png", "\u7a7a\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_kongcang@3x.png", "\u6ee1\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_mancang@3x.png", "\u51cf\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_jiancang@3x.png", "\u52a0\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_jiacang@3x.png", "\u6da8": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zhang@3x.png", "\u8dcc": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_die@3x.png", "\u8e29": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_cai@3x.png", "\u9876": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ding@3x.png", "\u80dc\u5229": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_shengli@3x.png", "\u91d1\u5e01": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_jinbi@3x.png", "dog\u6342\u8138": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dog_wulian2021-08-23@3x.png", "dog\u7b11\u54ed": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dog_xiaoku2021-08-23@3x.png", "\u7231\u5fc3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/aixin2021-08-23@3x.png", "\u5315\u9996": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/bishou2021-08-23@3x.png", "\u6284\u5e95": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/chaodi2021-08-23@3x.png", "\u5403\u74dc": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/chigua2021-08-23@3x.png", "\u5403\u8089": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/chirou2021-08-23@3x.png", "\u6253call": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dacall2021-08-23l@3x.png", "\u4e8c\u54c8": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/erha2021-08-23@3x.png", "\u7ea2\u5305": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/hongbao2021-08-23@3x.png", "\u97ed\u83dc": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/jiucai2021-08-23@3x.png", "\u9152": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/jiu2021-08-23@3x.png", "\u88c2\u5f00": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/liekai2021-08-23@3x.png", "\u5e72\u676f": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/pijiu2021-08-23@3x.png", "\u5e86\u795d": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/qingzhu2021-08-23@3x.png", "\u5fc3\u788e": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/xinsui2021-08-23@3x.png", "\u836f": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/yao2021-08-23@3x.png", "666": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/666_v3.png", "\u767d\u773c": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/baiyan_v3.png", "\u6253\u8138": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dalian_v3.png", "\u9f13\u638c": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/guzhang_v3.png", "\u62a0\u9f3b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/koubi_v3.png", "\u96be\u8fc7": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/nanguo_v3.png", "\u53f9\u6c14": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/tanqi_v3.png", "\u6293\u72c2": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/zhuakuang_v3.png", "\u9f87\u7259": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/ziya_v3.png", "\u4e70": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/0e2f6f9ac9666b0cbf46bbf18fb15528=200X200.png", "\u8df3\u6c34": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/d938c427247c2c9dfc0c0ff3edee75ed=200X200.png", "\u7a7a": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/7b5cc2714dc25772900d3c8924237b22=200X200.png", "\u591a": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/4fe79dc6598e28957f02439e81eb7a68=200X200.png", "\u5403\u9762": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/140199629c06eca7f7f4c63cec870bd0=200X200.png", "\u68ad\u54c8": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/90cb956f181acaf875b1c7a857937112=200X200.png", "\u5356": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/2263373d61c164c7ecd0d2551dc82323=200X200.png", "\u62b1\u62f3": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/f838a3021272c8fdfc580ad8992be7a7=100X100.png", "\u7948\u7977": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/cf0006b5b512a9e8d3946b19166d28c2=100X100.png", "\u63e1\u624b": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/e2d6ab55fc734846651fddf0fb363a06=100X100.png" },
            ending: false,
        }
    },
    created() {
        // preview_live_time
        // 判断一下当前的时间
        let nowDate = new Date().getTime();
        // 
        let cardTime = this.info.preview_live_time;
        if(typeof cardTime == 'string') {
            cardTime = cardTime.replace(/-/g, '/')
        }
        let cardDate = new Date(cardTime).getTime();

        if(nowDate > cardDate) {
            this.ending = true;
        } else {
            this.ending = false;
        }
    },
    methods: {
        // 字符串替换
        strParseFace(_str) {
            let json = this.faceList || [];
            let pattern1 = /\[.+?\]/g;
            let pattern2 = /\[.+?\]/;
            let contents = _str;
            let content = contents.match(pattern1);
            let str = contents;

            if (content && Object.keys(json).length > 0) {
                for (let i = 0; i < content.length; i++) {
                    let src = "";
                    for (let item in json) {
                        if ("[" + item + "]" === content[i]) {
                            src = `<img class="AGP_face" render="ext" src="${json[item]}" alt="${item}" title="${item}" type="face">`;

                            break;
                        }
                    }
                    if (src) {
                        str = str.replace(pattern2, src);
                    }
                }
            } else {
                return str;
            }

            return str;
        },
        // 跳转页面
        handleClickDetailPage() {
            let info = this.info
            if(info.kind == 'vip') {
                this.openNative('adv_live_msg', {
                    url: `/up/app/advLiveMsg?id=${info.id}&scroll_btm=no`
                });
            } else {
                this.openNative('detail_page', {
                    o_kind: info.kind,
                    id: info.id,
                    name: info.l_title || info.title,
                    scroll_btm: 'no',
                    query: info,
                    type: this.pageName
                });
            }
        },
        // 跳转APP页面
        openNative(type, query = {}) {
            let params = {
                kind: type, // 类型
            };

            params ={
                ...params,
                ...query
            }

            switch (type) {
                case "detail_page": // 详情页
                    break;
                case "video_live_page": // 视频直播间
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native', params)
        },
        // 
        handleClick() {
			if(!isLoginInfo()) {
				return
			}
            let info = this.info;
            if(this.ending) {
                if(this.info.room_state == '1') {
                    this.openNative("video_live_page", {
                        id: info.preview_room_id
                    })
                } else if(this.info.room_state == '0') {
                    Toast({
                        type: "html",
                        message: "<div class='stockGroupTips'>本场直播未开播或已超时！</div>",
                        position: "bottom"
                    })
                }
                else {
                    Toast({
                        type: "html",
                        message: "<div class='stockGroupTips'>本场直播已结束！</div>",
                        position: "bottom"
                    })
                }
                
            } else {
                // info.room_preview_state == '0' 未预约 
                if(this.userInfo.u_id == u_id) {
                    Toast({
                        type: "html",
                        message: "<div class='stockGroupTips'>不能预约自己的直播！</div>",
                        position: "bottom"
                    })
                    return
                }
                let uid = info.u_id;

                if(info.kind == 'user_msg') {
                    uid = info.l_id;
                }

                let query = {
                    reserved_u_id: uid,
                    msg_id: info.id,
                    msg_kind: "live_msg"
                }
                if(info.room_preview_state == '1') {
                    query.reserve_kind = "cancel"

                    Dialog.confirm({
                        message: '确认要取消预约吗？',
                        confirmButtonText: "确认",
                        cancelButtonText: "再想想"
                    })
                    .then(() => {
                        // on confirm
                        this.reqAPI(query, info)
                    })
                    .catch(() => {
                        // on cancel
                    });
                } else {
                    this.reqAPI(query, info)
                }
            }
        },
        async reqAPI(query, info) {
            let res = await userHomeApi.setReserve(query);
            console.info(res, "res")
            if(res.code == 1){
                if(info.room_preview_state == '0') {
                    Dialog.alert({
                        title: '预约成功',
                        message: '主播开播时，您将会收到站内通知和站外推送。',
                    }).then(() => {
                        // on close
                    });
                    this.$set(this.info,'room_preview_state', 1)
                } else {
                    Toast({
                        type: "html",
                        message: "<div class='stockGroupTips'>取消预约成功！</div>",
                        position: "bottom"
                    })
                    this.loading = false;
                    this.$set(this.info,'room_preview_state', 0)
                }
            }
        }
    },
    computed: {
        liveStr() {
            let _str = "";
            if(this.ending) {
                switch(this.info.room_state * 1) {
                    case 0:
                        _str = "未开播";
                        break;
                    case 1:
                        _str = "直播中";
                        break;
                    case 2:
                        _str = "已结束";
                        break;
                }
            } else {
                switch(this.info.room_preview_state * 1) {
                    case 0:
                        _str = "预约";
                        break;
                    case 1:
                        _str = "已预约";
                        break;
                }
            }

            return _str;
        }
    }
}
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
.liveCardWrap {
    padding:rem2(8px) rem2(12px) 0;

    .liveCardMain {
        width: 100%;
        height: auto;
        border-radius: rem2(10px);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: rem2(8px) rem2(12px) rem2(12px);
        box-sizing: border-box;
        background-color: #FFFAF8;
        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/live_bg.svg");
        background-repeat: no-repeat;
        background-position: right bottom;
        background-size: rem2(142px) rem2(58px);
        overflow: hidden;
        box-shadow: rem2(1px) rem2(1px) rem2(3px) rem2(2px) #FDF4F0;

        .liveCardLeft {

            .liveCardTitle {
                padding-left: rem2(20px);
                font-size: rem2(13px);
                line-height: rem2(18px);
                height: rem2(18px);
                color: #FF7443;
                font-weight: 500;
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/live_notice.png");
                background-size: rem2(15.58px) auto;
                background-repeat: no-repeat;
                background-position: left top;
            }

            .liveCardContent {
                padding-top: rem2(12px);

                p {
                    font-size: rem2(16px);
                    line-height: rem2(21px);
                    color: #333;
                }
            }

            .liveCardTime {
                font-size: rem2(13px);
                line-height: rem2(16px);
                color: #939393;
                margin-top: rem2(12px);
            }
        }

        .liveCardRight {
            display: flex;
            flex-direction: row;
            align-items: center;

            button {
                width: rem2(70px);
                height: rem2(32px);
                border-radius: rem2(17px);
                border: none;
                outline: none;
                font-size: rem2(13px);
                color: #fff;
                background-color: #CACACA;

                &.liveCardAppPoint {
                    background-color: #FE484A;
                    background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/live_bell.svg");
                    background-repeat: no-repeat;
                    background-position: rem2(15px) center;
                    background-size: rem2(10px) rem2(13px);
                    padding:0 0 0 rem2(16px);
                }

                &.liveCardLight {
                    background-color: #FE484A;
                }
            }
        }
    }
}
</style>